import React, { PureComponent } from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import { Field, reduxForm } from 'redux-form'
import { Col, Glyphicon, FormControl, FormGroup, InputGroup, Button, Alert } from 'react-bootstrap'
import Access from '../Access'

const validate = (values, { t }) => {
  const errors = {}
  if (!values.emailAddress) {
    errors.emailAddress = t('GLOBAL.FORMS.REQUIRED')
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailAddress)) {
    errors.emailAddress = t('GLOBAL.FORMS.INVALID_EMAIL_ADDRESS')
  }
  return errors
}

const renderField = ({ id, actions, icon, name, input, placeholder, type, meta: { error, touched } }) => (
  <FormGroup className={'colWidth-100 ' + (error && touched ? 'has-error' : '')}>
    <Col>
      <InputGroup className="input-group-icon">
        <InputGroup.Addon>
          <Glyphicon bsClass='iconsprite' glyph={icon} />
        </InputGroup.Addon>
        <FormControl id={id} type={type} placeholder={placeholder} {...input} />
      </InputGroup>
      {error && touched &&
        <span className='help-block text-center'>{error}</span>
      }
    </Col>
  </FormGroup>
)

class RememberPassword extends PureComponent {
  render () {
    const { t, handleSubmit, error, emailSended, invalid, submitting, actions: { rememberPassword } } = this.props
    const onSubmit = (values) => {
      return new Promise((resolve, reject) => {
        rememberPassword(values, resolve, reject)
      })
    }
    var dataTheme = localStorage.getItem('theme')
    let CompanyLogo
    let poweredBy
    switch (dataTheme) {
      case 'dark':
        CompanyLogo = <img src='images/CompanyLogoD.png'></img>
        poweredBy = <img src="images/poweredbyD.png" ></img>
        break
      default:
        CompanyLogo = <img src='images/CompanyLogo.png'></img>
        poweredBy = <img src="images/poweredby.png" ></img>
        break
    }
    return (
      <Access>
        <div className='loginContainer'>
          <form id='RememberPassword' className="auth" onSubmit={handleSubmit(onSubmit)}>
            <div className='elementContainer'>
              <div className='clientBox'>
                <h2>Welcome to</h2>
                {CompanyLogo}
              </div>
              <div className='loginBox'>
                {poweredBy}
                <h1 className="logintext">{t('REMIND_PASSWORD.REMIND_PASSWORD')}</h1>
                <div className='fieldsContainer'>
                  <Field
                    id='email_remember'
                    name='emailAddress'
                    icon='form-input-email'
                    placeholder={t('REMIND_PASSWORD.INSERT_EMAIL')}
                    component={renderField}
                  />
                  { emailSended && (
                    <div className='infoBox' id="sendMail">
                      <Alert bsStyle='warning' role='warning'>
                        <strong>{t('REMIND_PASSWORD.EMAIL_SENDED')} 1</strong>
                      </Alert>
                    </div>
                  )}
                  { error &&
                    <div className='infoBox' id='serverError'>
                      <Alert bsStyle='danger' role='alert'>
                        <strong>{t('ERRORS.SERVER_ERROR')} 2</strong>
                        <p>{error}</p>
                      </Alert>
                    </div>
                  }
                </div>
                <div className='flexInLine al-C'>
                  <LinkContainer to="/login">
                    <Button
                      id='btn_back'
                      type='button'
                      bsStyle='warning'
                      className='_Btn accept'
                      name='btn-prev'
                    >{t('REMIND_PASSWORD.BACK')}</Button>
                  </LinkContainer>
                  <Button
                    id='btn_send'
                    type='submit'
                    bsStyle='primary'
                    className='_Btn new'
                    name='btn-remember-auth'
                    disabled={invalid || submitting}
                  >{t('REMIND_PASSWORD.SEND')}</Button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className='transpContainer'></div>
      </Access>
    )
  }
}

export default reduxForm({
  form: 'rememberPassword',
  validate
})(RememberPassword)
